'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var UnrevealedContext = React.createContext({
    features: [],
    loading: true,
    error: null
});

function UnrevealedProvider(_a) {
    var clientKey = _a.clientKey, children = _a.children;
    var _b = React.useState([]), features = _b[0], setFeatures = _b[1];
    var _c = React.useState(true), loading = _c[0], setLoading = _c[1];
    var _d = React.useState(null), error = _d[0], setError = _d[1];
    React.useEffect(function () {
        fetch('https://edge.unrevealed.tech', {
            method: 'get',
            headers: { 'Client-Key': clientKey }
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            setFeatures(data.features);
        })["catch"](function (err) {
            setError(err.message);
        })["finally"](function () {
            setLoading(false);
        });
    }, [clientKey]);
    return (React__default["default"].createElement(UnrevealedContext.Provider, { value: { features: features, loading: loading, error: error } }, children));
}

function useFeature(featureKey) {
    var _a = React.useContext(UnrevealedContext), error = _a.error, loading = _a.loading, features = _a.features;
    return {
        enabled: features.includes(featureKey),
        loading: loading,
        error: error
    };
}

exports.UnrevealedProvider = UnrevealedProvider;
exports.useFeature = useFeature;
//# sourceMappingURL=main.js.map
